// HudView.js — score, steps remaining, and the active lyric line.
// The lyric line is rendered one <span> per character so each can be colored
// independently as the song is sung (karaoke-style sync). Spans are rebuilt
// only when the line changes; per-frame updates just toggle classes.

import { Phase } from "../core/GameState.js";

export class HudView {
    constructor({ scoreEl, stepsEl, lineEl, statusEl }) {
        this._scoreEl = scoreEl;
        this._stepsEl = stepsEl;
        this._lineEl = lineEl;
        this._statusEl = statusEl;

        this._renderedLine = -1;
        this._spans = [];
    }

    render(state) {
        this._scoreEl.textContent = state.score;
        this._stepsEl.textContent = state.stepsLeft;

        if (this._statusEl) {
            const status = state.feedbackMessage || STATUS_TEXT[state.phase] || "";
            this._statusEl.textContent = status;
            this._statusEl.classList.toggle("status--alert", state.feedbackType === "miss");
        }

        this._renderLyric(state);
    }

    _renderLyric(state) {
        // Rebuild the per-character spans only when the line actually changes.
        if (state.lineIndex !== this._renderedLine) {
            this._renderedLine = state.lineIndex;
            this._spans = state.lineChars.map((ch) => {
                const span = document.createElement("span");
                span.className = "ch";
                span.textContent = ch;
                return span;
            });
            this._lineEl.replaceChildren(...this._spans);
        }

        // Cheap per-frame update: color by position relative to the sung char.
        const active = state.activeCharIndex;
        for (let i = 0; i < this._spans.length; i++) {
            const span = this._spans[i];
            span.classList.toggle("ch--sung", i < active);
            span.classList.toggle("ch--active", i === active);
            span.classList.toggle("ch--upcoming", i > active);
        }
    }
}

const STATUS_TEXT = {
    [Phase.LOADING]: "Loading…",
    [Phase.READY]: "Tap to start",
    [Phase.PLAYING]: "",
    [Phase.LINE_DONE]: "Line clear!",
    [Phase.SONG_END]: "Finished",
};
